import {
  Flex,
  Text,
  Badge,
  Spacer,
  Box,
  InputGroup,
  InputLeftElement,
  Input
} from '@chakra-ui/react'
import { ChangeEvent, FC, useEffect, useState } from 'react'
import { BsSearch } from 'react-icons/bs'

import useParametrizationSimilarProduct from '@hook/parametrization/use-similar-product'

import ParametrizationSimilarProductCreate from '@component/Parameterization/SimilarProduct/ModalCreate'
import ParametrizationSimilarModalDelete from '@component/Parameterization/SimilarProduct/ModalDelete'

const SelectedTableBar: FC = () => {
  const {
    selected,
    getData,
    setQuery,
    query: lastQuery
  } = useParametrizationSimilarProduct()
  const [query, setQueryNew] = useState(lastQuery)
  const [queryLast, setQueryNewLast] = useState(lastQuery)

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    // getData(value, 0, 50, true)
    setQueryNew(value)
    setQuery(value)
  }
  useEffect(() => {
    if (query.trim() !== '' || queryLast !== '') {
      const delayDebounceFn = setTimeout(() => {
        setQueryNewLast(query)
        // Chama a API somente se o valor não estiver vazio
        getData(query, 0, 50, true)
      }, 2000) // Atraso de 2 segundos após a última alteração no inputValue

      return () => clearTimeout(delayDebounceFn)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query])

  // useEffect(() => {
  //   const delayDebounceFn = setTimeout(() => {
  //     console.log('aqui 2', query)
  //     // Chama a API somente se o valor não estiver vazio
  //     if (query.trim() !== '') {
  //       getData(query, 0, 50, true)
  //     }
  //   }, 2000) // Atraso de 2 segundos após a última alteração no inputValue

  //   return () => clearTimeout(delayDebounceFn)
  // }, [query])
  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      alignItems="center"
      justifyContent="space-between"
      paddingY={2}
      paddingX={4}
    >
      <Flex alignItems="center">
        <Badge
          h="16px"
          minW="16.5px"
          marginRight={2}
          ml="1"
          color="#4b64c9"
          border="1px solid #4b64c9"
          background="#c0d9ff"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {selected !== 0 ? 1 : 0}
        </Badge>
        <Text color={'black'}>Itens Selecionados</Text>
      </Flex>

      <Spacer />
      <Box w="240px" pl={2} pr={4}>
        <InputGroup size="sm" borderColor="gray.200">
          <InputLeftElement pointerEvents="none">
            <BsSearch color="var(--chakra-colors-gray-400)" />
          </InputLeftElement>
          <Input
            placeholder="Buscar..."
            borderRadius="8px"
            pl={8}
            value={query}
            onChange={handleInputChange}
            isDisabled={false}
            _hover={{
              borderColor: 'yellow.400'
            }}
            _placeholder={{
              color: 'gray.400'
            }}
          />
        </InputGroup>
      </Box>

      {selected !== 0 ? <ParametrizationSimilarModalDelete /> : []}
      <ParametrizationSimilarProductCreate />
    </Flex>
  )
}

export default SelectedTableBar
